import React from "react";
import { SmallText, Text } from "../../styles/Text";
import { t } from "../../i18n";

const NoResults = () => <SmallText>{t("general.noResults")}</SmallText>;

export default NoResults;
